import billingModule from './billing.module';

export default billingModule.config($stateProvider =>
    $stateProvider
        .state({
            parent: 'app',
            name: 'billing',
            url: '/billing',
            component: 'billing',
            redirectTo: 'billing_overview'
        })
        .state({
            parent: 'billing',
            name: 'billing_overview',
            url: '/overview',
            component: 'billingOverview',
            protected: true
        })
        .state({
            name: 'billing_guest',
            url: '/billing/guest',
            component: 'billingGuest',
            protected: false
        })
        .state({
            parent: 'billing',
            name: 'billing_otherwise',
            url: '/*path',
            redirectTo: 'billing_overview'
        })
);



// WEBPACK FOOTER //
// ./modules/billing/billing.states.js